module.exports = __webpack_public_path__ + "img/PRCA2_CD8Tex.9e7a1e88.png";